import { useSelector } from 'react-redux';
import { userSelectors } from '@/Redux/User';

export function useTableStateStoringKey(key: string): string {
  const user = useSelector(userSelectors.currentUser);

  return `${key}_UserID:${user?.id ?? -1}`;
}
